"use client"

import { useLayoutEffect, useRef } from "react"

import Image, { type ImageProps } from "next/image"

let nextId = 0

// Must keep view transition name unique per transition.
export function SafariViewTransitionFix(props: ImageProps) {
  const ref = useRef<HTMLImageElement>(null)

  useLayoutEffect(() => {
    ref.current?.style.setProperty(
      "view-transition-name",
      `post-cover-image-${nextId++}`,
    )
  }, [])

  // eslint-disable-next-line jsx-a11y/alt-text
  return <Image {...props} ref={ref} />
}
